<template>
  <div>
    <main class="page__container">
      <div class="container">
        <h2>Создание новой Hardware группы</h2>
        <el-form ref="form" :rules="rules" :model="form">
          <el-row :gutter="20">
            <el-col :span="12">
              <el-form-item label="Имя" prop="name">
                <el-input v-model="form.name" size="small" />
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="20">
            <el-col :span="8">
              <server-select
                v-model="selectedMCores"
                :source="sources.mcore"
                label="MCores"
                multiple
                :multiple-limit="2"
                show-quota
              />
            </el-col>
            <el-col :span="8">
              <server-select
                v-model="selectedArchCores"
                :source="sources.archcore"
                label="ArchCores"
                multiple
                :disabled="!selectedMCores.length"
              />
            </el-col>
            <el-col :span="8">
              <server-select
                v-model="selectedArchCaster"
                :source="sources.archcaster"
                label="Archive Caster"
                clearable
                :disabled="!selectedMCores.length"
              />
            </el-col>
          </el-row>
        </el-form>
      </div>
    </main>
    <el-footer class="page__active_bar">
      <div class="page__active_buttons">
        <el-button type="info" plain @click="$router.push({ name: 'hw-groups', params: { page: 1 } })">
          Отменить
        </el-button>
        <el-button type="primary" :disabled="!canSave" :loading="fetch" @click="submit">
          Сохранить
        </el-button>
      </div>
    </el-footer>
  </div>
</template>
<script>
import { length, required } from "@/core/helpers/validators";
import { mapActions } from "vuex";
import ServerSelect from "./ServerSelect";
import { ARCHCASTER_SOURCE, ARCHCORE_SOURCE, MCORE_SOURCE } from "../serverSources";

export default {
  name: "HwGroupCreate",
  components: { ServerSelect },
  data() {
    return {
      fetch: false,
      form: {
        name: "",
      },
      rules: {
        name: [required(), length(3, 200)],
      },
      sources: {
        mcore: MCORE_SOURCE,
        archcore: ARCHCORE_SOURCE,
        archcaster: ARCHCASTER_SOURCE,
      },
      selectedMCores: [],
      selectedArchCores: [],
      // По схеме AddHardwareGroup ArchCaster у группы один — id_archive_caster, число.
      selectedArchCaster: null,
    };
  },
  computed: {
    canSave() {
      return (
        this.$can("create", "hardware_groups") &&
        !!this.form.name &&
        this.selectedMCores.length > 0 &&
        this.selectedArchCores.length > 0 &&
        !!this.selectedArchCaster
      );
    },
  },
  watch: {
    // Сценарий 2.1: без MCore выбор ArchCore и Archive Caster блокируется и сбрасывается.
    // На редактировании (2.2) ограничений нет, поэтому там такого сброса нет.
    selectedMCores(mcores) {
      if (mcores.length) return;
      this.selectedArchCores = [];
      this.selectedArchCaster = null;
    },
  },
  methods: {
    ...mapActions("hwGroups", {
      addHwGroup: "ADD_HW_GROUP",
    }),
    submit() {
      let formIsValid;
      this.$refs["form"].validate((status) => {
        formIsValid = status;
      });
      if (!formIsValid || !this.canSave) return false;

      this.fetch = true;
      const newHardwareGroup = {
        name: this.form.name,
        proxy_servers: [...this.selectedMCores],
        servers: [...this.selectedArchCores],
        id_archive_caster: this.selectedArchCaster,
      };

      this.addHwGroup(newHardwareGroup)
        .then(() => {
          this.$router.push({ name: "hw-groups", params: { page: 1 } });
          this.$message({
            message: "Группа создана",
            type: "success",
          });
        })
        .catch((e) => {
          this.$message({
            type: "error",
            message: (e.response && e.response.data.error) || "Неизвестная ошибка",
          });
        })
        .finally(() => {
          this.fetch = false;
        });
    },
  },
};
</script>
<style scoped>
.page_container {
  padding: 20px;
}
.page__active_buttons {
  display: flex;
  justify-content: flex-end;
  gap: 11px;
  padding: 11px 0;
}
</style>
